import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
class Setexecutive extends Component {

  state = {
    executives: [],
    selectedExecutives: [],
    load: false,
    set: [],
  }

  componentDidMount() {
    this.setSelectedExecutives();
  }

  setAllExecutives(selected) {
    let context = this;
    var executive = [];
    this.props.executive.map((y) => {
      executive.push({key: y.name, text: y.name, value: y.id});
    });
    this.setState({
      executives: executive
    });
  }

  setSelectedExecutives() {
    let context = this;
    var selected = [];
    this.props.data.map((z) => {
      if (z.type == 'executive') {
        if (z.account == context.props.id) {
          context.props.executive.map((y) => {
            let b= true;
            for (var i = 0; i < selected.length; i++) {
              if (selected[i].value == y.id) {
                b = false;
                break;
              }
            }
            if (z.upi == y.id && b) {
              selected.push(z.upi);
            }
          });
        }
      }
    });
    context.setState({
      selectedExecutives: selected,
      set: selected
    });
    this.setAllExecutives(selected);
  }

  category = (f, { value }) => {
    if (!this.props.menuPermission.edit) {
      alert('Access Denied');
      return;
    }
    this.check(value, this.state.selectedExecutives);
    this.setState({ selectedExecutives: value })
  }

  add(val) {
    let context = this;
    let data = {'id': this.props.id, 'executive': val};
    context.setState({
      load: true,
      message: 'Adding Executive'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'upidetails/addexecutive.php',
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.setState({
            load: false,
          })
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  remove(val) {
    let context = this;
    let data = {'id': this.props.id, 'executive': val};
    context.setState({
      load: true,
      message: 'Removing Executive',
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'upidetails/removeexecutive.php',
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {

        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  check(value, oldValue) {
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      let array1 = oldValue.filter(val => !value.includes(val));
      this.remove(array1[0]);
    }
  }

  render() {
    let { executives, selectedExecutives, load, message } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
        <Dropdown placeholder='Executive' style={{ borderColor: '#5A9CBB', fontSize: 12 }}
         multiple fluid search selection onChange={this.category}
         options={executives} value={selectedExecutives} />
         {loading}
      </div>
    );
  }
}

export default Setexecutive;
